<template>
  <div class="setting-phone">
    <div class="row_phone hp_cz_center_s now_tel">
      <div class="lable">当前手机号：</div>
      <div class="val">{{ oldMobile }}</div>
    </div>
    <div class="row_phone">
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-form-model-item prop="mobile">
          <a-input v-model="formInline.mobile" placeholder="请输入新的手机号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="code">
          <div class="code">
            <a-input v-model="formInline.code" placeholder="请输入验证码"></a-input>
            <a-button :disabled="disabled" @click="getCode" class="btn" type="link" block>{{ txt }}</a-button>
          </div>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="upload" type="primary" html-type="submit">确认修改</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="row_phone">
      <span class="tip">温馨提示：您可使用该手机号登录健康淮南APP</span>
    </div>
  </div>
</template>
<script>
import { getMemberDetail, editMember } from "@/api/user-center";
import { getCode } from "@/api/user";
import { ls } from "@/utils/tool";
var count = 60,
  timer = null;
export default {
  data() {
    let checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号码"));
      }
      let zz = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
      if (!zz.test(value)) {
        callback(new Error("手机号码格式错误"));
      } else {
        callback();
      }
    };
    return {
      sysUser: ls.get("sysUser"),
      oldMobile: "",
      disabled: false,
      txt: "验证码",
      formInline: {},
      rules: {
        mobile: [
          {
            validator: checkMobile,
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "change" }],
      },
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  destroyed() {
    clearInterval(timer);
    count = 60;
    timer = null;
  },
  methods: {
    async init() {
      var res = await getMemberDetail({
        memberId: this.sysUser.id,
      });
      console.log("res.data===", res.data);
      this.formInline = res.data;
      this.formInline.code = "";
      this.formInline.fromType = "5";
      this.oldMobile = this.formInline.mobile;
    },
    async getCode() {
      this.disabled = true;
      var res = await getCode(this.formInline.mobile);
      console.log("getCode=====", res);
      if (res.code !== 200) {
        this.$message.error(res.message);
        this.disabled = false;
        return;
      }
      if (timer == null) {
        timer = setInterval(() => {
          count--;
          this.txt = count + "秒后获取验证码";
          if (count <= 0) {
            this.disabled = false;
            clearInterval(timer);
            this.txt = "获取验证码";
            timer = null;
          }
        }, 1000);
      }
    },
    handleSubmit() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          var res = await editMember(this.formInline);
          if (res.code == 200) {
            this.$message.success("修改成功");
            this.$router.push("/");
          }
        } else {
          console.log("提交错误!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.setting-phone {
  margin-left: 240px;
  .now_tel {
    margin-top: 30px;
    margin-bottom: 50px;
    .lable {
      color: #0096fa;
      font-size: 20px;
      font-weight: bold;
    }
    .val {
      color: #666;
      font-size: 20px;
    }
  }
  .row_phone {
    width: 380px;
    input {
      font-size: 20px;
      height: 47px;
    }
    .code {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      .btn {
        width: 100px;
      }
    }
    .upload {
      width: 379px;
      height: 52px;
      background: #0096fa;
      border-radius: 4px;
      font-size: 20px;
      font-weight: 400;
      color: #ffffff;
      line-height: 52px;
    }
    .tip {
      font-size: 16px;
      font-weight: 400;
      display: block;
      color: #999999;
    }
  }
}
</style>
